import axios from 'axios';
import { qrOrderingApiURL } from './QrOrderingApiConfig';

// Separate client: guests do not need platform credentials or token refreshes.
const guestApi = axios.create({
  baseURL: qrOrderingApiURL,
  withCredentials: false,
  headers: { Authorization: null, 'ngrok-skip-browser-warning': 'true' },
});

export const getGuestMenu = (tableToken) => guestApi.get(`guest/tables/${encodeURIComponent(tableToken)}/menu/`);
export const submitGuestOrder = (tableToken, data) => guestApi.post(`guest/tables/${encodeURIComponent(tableToken)}/orders/`, data);
export const getGuestOrderStatuses = (tableToken, submissionIds) => guestApi.post(`guest/tables/${encodeURIComponent(tableToken)}/order-status/`, { submission_ids: submissionIds });

export const getGuestTableBill = tableToken => guestApi.get(`guest/tables/${encodeURIComponent(tableToken)}/bill/`);
